import { Box, SvgIcon } from '@mui/material';
import React from 'react';
import { useTranslation } from 'react-i18next';

import { palette, spaces } from '../../assets/styles/themes/tokens';
import AIAssistantChatHistory from '../../components/AIAssistant/Page/ChatHistory/AIAssistantChatHistory';
import MasterLayout from '../../components/AppLayout/MasterLayout';
import AssistantSectionTopBar from '../../components/PageToolbar/AssistantSectionTopBar';
import getMuiIcon from '../../utils/getMuiIcon';
import useScreenSize from '../../utils/useScreenSize';

const getPageContainerStyles = (isSmallScreen: boolean) => ({
	display: 'flex',
	padding: isSmallScreen
		? `${spaces.md} ${spaces.md}`
		: `0 ${spaces.xxxxxl} ${spaces.xxxxl} ${spaces.xxxxxl}`,
	flexDirection: 'column',
	alignItems: 'center',
	gap: spaces.xl,
	flex: '1 0 0',
	alignSelf: 'stretch',
	background: palette.background.paperElevation1,
});

const HISTORY_TOOLBAR_ICON_SIZE = 20;

const historyToolbarIconSx = {
	color: palette.text.primary,
	width: HISTORY_TOOLBAR_ICON_SIZE,
	height: HISTORY_TOOLBAR_ICON_SIZE,
};

const HistoryPage: React.FC = () => {
	const { t } = useTranslation();
	const { isXsScreen, isSmScreen } = useScreenSize();
	const isSmallScreen = isXsScreen || isSmScreen;

	const getTopBarContent = () => {
		return (
			<AssistantSectionTopBar
				data-testid="history-toolbar"
				icon={
					<SvgIcon component={getMuiIcon('recent')} sx={historyToolbarIconSx} viewBox="0 0 24 24" />
				}
				title={t('History')}
			/>
		);
	};

	return (
		<MasterLayout customTopBarContent={!isSmallScreen && getTopBarContent()}>
			<Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
				{isSmallScreen && getTopBarContent()}
				<Box sx={getPageContainerStyles(isSmallScreen)} data-testid="history-page">
					<AIAssistantChatHistory />
				</Box>
			</Box>
		</MasterLayout>
	);
};

export default HistoryPage;
